module.exports = __webpack_public_path__ + "static/media/S1N7-6.34f70e01.svg";